import checkMarkGreen from '../../../assets/images/checked-green.png';
import checkMarkGreenRounded from '../../../assets/images/icon-checked-green-rounded.png';
import paymentIconCC from '../../../assets/images/paymentcons/payments-sprite3.png';
import paymentIconVisa from '../../../assets/images/paymentcons/icon-visa.png';
import paymentIconMasterCard from '../../../assets/images/paymentcons/icon-master-card.png';
import paymentIconDinersClub from '../../../assets/images/paymentcons/icon-diners-club.png';
import paymentIconDiscover from '../../../assets/images/paymentcons/icon-discover.png';
import paymentIconJcb from '../../../assets/images/paymentcons/icon-jcb.png';
import paymentIconAmex from '../../../assets/images/paymentcons/icon-amex.png';
import paymentIconPayPal from '../../../assets/images/paymentcons/icon-paypal.png';
import paymentIconSepa from '../../../assets/images/paymentIconSepa1.png';
import paymentIconIdeal from '../../../assets/images/paymentIconIdeal.png';
import paymentIconCoinbase from '../../../assets/images/paymentcons/paymentIconCoinbase1_1.png';
import iconError from '../../../assets/images/icon-error.png';
import deleteRed from '../../../assets/images/icon-delete-red2.png';
import exclamation from '../../../assets/images/icon-exclamation-mark.png';

export const useStyles = (theme) => ({
	paymentSection: {
		'& label.MuiFormLabel-root': {
			display: 'block',
			transform: 'translate(0px, -20px)',
			fontSize: 13,
			fontWeight: 700,
			color: '#283339',
		},
		'& .MuiFormControl-root .MuiOutlinedInput-root': {
			borderRadius: 6,
			background: '#ffffff',
			border: '1px solid #D4D6D7'
		},
		'& .MuiOutlinedInput-root .MuiOutlinedInput-input': {
			padding: '18px 14px',
			color: '#283339',
			fontSize: 13,
			fontWeight: 600,
		},
		'& .MuiFormControl-root .MuiOutlinedInput-root.Mui-focused': {
			border: '1px solid #858ADA',
		},
		'& .MuiFormControl-root .MuiOutlinedInput-root.Mui-error': {
			border: '1px solid #E52866',
		},
		'& .MuiInputLabel-outlined.MuiInputLabel-shrink .MuiInputLabel-asterisk': {
			display: 'none',
		}
	},
	hide: {
		display: 'none !important',
	},
	textBold: {
		fontWeight: '700 !important',
	},
	countrySelectItem: {
		position: 'relative',
		fontSize: 13,
		fontWeight: 600,
		color: '#283339',
		padding: '15px 10px 15px 40px',
		borderBottom: '1px solid #E6E5E5',
		'&:hover': {
			background: '#5058C8',
			color: '#ffffff',
		},
		'&$countrySelectItemActive': {
			background: '#5058C8',
			color: '#ffffff',
			'&:before': {
				content: '""',
				position: 'absolute',
				top: 14,
				left: 15,
				width: 8,
				height: 16,
				borderBottom: '2px solid #ffffff',
				borderRight: '2px solid #ffffff',
				transform: 'rotate(45deg)'
			},
			'&:hover': {
				background: '#5058C8',
				color: '#ffffff',
			},
		}
	},
	countrySelectItemActive: {

	},
	sectionHeader: {
		color: '#283339',
		fontSize: 24,
		fontWeight: 700,
		lineHeight: '36px',
		padding: '10px 0 20px',
		margin: 0,
	},
	separator: {
		height: 1,
		background: '#E6E5E5',
		margin: '0 10px 60px',
	},
	paper: {
		marginTop: theme.spacing(8),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main,
	},
	blockInfoTitle: {
		color: '#283339',
		fontSize: 28,
		fontWeight: 600,
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(3),
	},
	formControl: {
		minWidth: 120,
		marginTop: 20,
	},
	fieldWrapper: {
		position: 'relative',
	},
	eyeIcon: {
		position: 'absolute',
		right: 18,
		top: 23,
		width: 24,
		height: 20,
		cursor: 'pointer',
		zIndex: 1,
		color: '#41494f',
		fontSize: 18,
		textAlign: 'center',
	},
	eyeCloseIcon: {

	},
	accountInfoBlock: {
		borderRadius: 12,
		background: '#ffffff',
		padding: '30px 0',
		marginBottom: 45,
		'& label.MuiFormLabel-root': {
			fontSize: 16,
		}
	},
	checkboxError: {
		color: '#E52866',
	},
	formErrorText: {
		color: '#E52866',
		fontSize: 14,
		fontWeight: 500,
		lineHeight: '16px',
		padding: '10px 0'
	},
	errorIcon: {
		display: 'block',
		position: 'relative',
		paddingLeft: 25,
		fontSize: 11,
		fontWeight: 600,
		color: '#E52866',
		'&::before': {
			content: '""',
			display: 'block',
			position: 'absolute',
			top: '-2px',
			left: 3,
			width: 15,
			height: 13,
			backgroundImage: `url(${iconError})`,
			backgroundSize: 'cover',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
		},

	},
	errorText: {
		position: 'absolute',
		top: 73,
		left: 15,
		width: 'calc(100% + 15px)',
		color: '#f44336',
		fontSize: '0.75rem',
		lineHeight: 1,
	},
	planFeaturesDeleteIcon: {

	},
	formInput: {
		marginTop: 20,
	},
	freemiumWrapper: {

	},
	loginBtnWrapper:  {
		minWidth: '100%',
		'& $errorIcon': {
			float: 'right',
		}
	},
	loginBtnContainer: {
		minWidth: '100%',
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		'& a': {
			color: '#A6A9AB',
			fontSize: 14,
			fontWeight: 600,
			textDecoration: 'none',
			marginRight: 20,
		},
	},
	button: {
		margin: theme.spacing(1, 0, 1),
		color: '#fff',
		backgroundColor: '#ff8f00',
		border: 'none',
		padding: 10,
		fontSize: 16,
		fontWeight: 700,
		borderRadius: 50,
		fontFamily: 'Spartan, sans-serif',
		textTransform: 'initial',
		'&:hover': {
			backgroundColor: '#f18f00',
			border: 'none',
		},
	},
	loginButton: {
		maxWidth: 150,
	},
	freemiumSubmit: {
		maxWidth: 350,
		margin: theme.spacing(1, 0, 1),
	},
	paymentBlock: {

	},
	paymentWrapper: {
		position: 'relative',
		marginBottom: 20,
		borderRadius: 10,
		backgroundColor: '#ffffff',
		border: '1px solid #e6e5e5',
	},
	paymentWrapperOverlay: {
		position: 'absolute',
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		zIndex: 1000,
	},
	paymentTitleContainer: {
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
		padding: 20,
	},
	paymentTitleCircle: {
		width: 24,
		minWidth: 24,
		maxWidth: 24,
		height: 24,
		background: '#ffffff',
		border: '2px solid #d4d6d7',
		borderRadius: 12,
		display: 'inline-block',
		marginRight: 15,
	},
	paymentTitle: {
		color: '#6d7173',
		fontFamily: 'Spartan, sans-serif',
		fontWeight: 600,
		fontSize: 14,
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
	},
	pTitle: {
		marginTop: 3,
		marginRight: 10,
	},
	paymentIcon: {

	},
	paymentMethodContainer: {
		display: 'none',
		background: '#ffffff',
		borderRadius: 12,
	},
	paymentMethodContainerShow: {
		display: 'block',
	},
	paymentActive: {
		'&$paymentWrapper': {
			border: '3px solid #28D799',
		},
		'& $paymentTitleContainer': {
			padding: 16,
		},
		'& $paymentTitleCircle': {
			background: 'transparent',
			border: '7px solid #28D799',
		},
		'& $paymentTitle': {
			color: '#283339',
		},
	},
	paymentDisabled: {
		'& $paymentTitleContainer': {
			cursor: 'not-allowed',
		},
	},
	paymentIconCC: {
		'& $paymentIcon': {
			display: 'block',
			width: 350,
			height: 32,
			backgroundImage: `url(${paymentIconCC})`,
			backgroundSize: '100%',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			maxWidth: 'calc(100% - 30px)',
		},
	},
	paymentIconSepa: {
		'& $paymentIcon': {
			padding: '4px 9px',
			border: '1px solid #D9D9D9',
			borderRadius: 4,
			'& span': {
				display: 'block',
				width: 34,
				height: 22,
				backgroundImage: `url(${paymentIconSepa})`,
				backgroundSize: '100%',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
			},
		},
	},
	paymentIconIdeal: {
		'& $paymentIcon': {
			padding: '4px 9px',
			border: '1px solid #D9D9D9',
			borderRadius: 4,
			'& span': {
				display: 'block',
				width: 25,
				height: 22,
				backgroundImage: `url(${paymentIconIdeal})`,
				backgroundSize: '100%',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
			},
		},
	},
	paymentIconPayPal: {
		'& $paymentIcon': {
			padding: '4px 9px',
			border: '1px solid #D9D9D9',
			borderRadius: 4,
			'& span': {
				display: 'block',
				width: 26,
				height: 23,
				backgroundImage: `url(${paymentIconPayPal})`,
				backgroundSize: '100%',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
			},
		},
	},
	paymentIconCoinbase: {
		'& $paymentIcon': {
			display: 'block',
			width: 48,
			height: 32,
			backgroundImage: `url(${paymentIconCoinbase})`,
			backgroundSize: '100%',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
		},
	},
	coinbillMethodItem: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		border: '1px solid #e6e5e5',
		padding: 6,
		margin: 3,
		width: 45,
		borderRadius: 4,
	},
	coinbillETH: {
		width: 12,
	},
	paymentIconCoinbill: {
		'& $paymentIcon': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-start',
			flexWrap: 'wrap',
			'& span.cb-icon': {
				position: 'relative',
				display: 'block',
				width: 18,
				height: 18,
				maxWidth: '100%',
				backgroundSize: '100%',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center',
				'&$coinbillETH': {
					width: 12,
				},
				'& span.cb-icon-tooltip': {
					visibility: 'hidden',
					opacity: 0,
					position: 'absolute',
					top: '-34px',
					left: 0,
					background: '#d4d6d7',
					color: '#283339',
					fontSize: 10,
					padding: '3px 6px',
					borderRadius: 3,
					zIndex: 100,
					transition: 'opacity 0.3s ease',
					transitionDelay: '0s',
					pointerEvents: 'none',
					'&:before': {
						content: '""',
						width: 6,
						height: 6,
						background: '#d4d6d7',
						position: 'absolute',
						bottom: '-3px',
						left: 6,
						transform: 'rotate(45deg)',
					}
				},
				'&:hover': {
					'& span.cb-icon-tooltip': {
						visibility: 'visible',
						opacity: 1,
						transitionDelay: '0.3s',
					}
				}
			}
		},
	},
	pwm: {
		'& $pTitle': {
			marginTop: 0,
		},
	},
	paymentWallMethodItem: {
		padding: 3,
		margin: '1px 3px',
		border: '1px solid #D9D9D9',
		borderRadius: 4,
		width: 47,
		height: 32,
		display: 'flex',
		alignItems: 'center',
	},
	pwMore: {
		color: '#283339',
		fontWeight: 600,
		fontSize: 12,
	},
	passwordContainer: {
		position: 'relative',
		paddingBottom: '20px !important',
	},
	savedPaymentWrapper: {
		display: 'flex',
		alignItems: 'center',
		marginTop: 5,
		color: '#6D7173',
		fontWeight: 600,
		fontSize: 12,
	},
	savedPaymentIcon: {
		display: 'block',
		marginRight: 5,
		backgroundSize: '100%',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center',
	},
	sepa: {
		'&$savedPaymentIcon': {
			width: 32,
			height: 20,
			backgroundImage: `url(${paymentIconSepa})`,
		}
	},
	paypal: {
		'&$savedPaymentIcon': {
			width: 26,
			height: 23,
			backgroundImage: `url(${paymentIconPayPal})`,
		}
	},
	visa:  {
		'&$savedPaymentIcon': {
			width: 33,
			height: 10,
			backgroundImage: `url(${paymentIconVisa})`,
		}
	},
	mastercard: {
		'&$savedPaymentIcon': {
			width: 30,
			height: 19,
			backgroundImage: `url(${paymentIconMasterCard})`,
		}
	},
	diners: {
		'&$savedPaymentIcon': {
			width: 34,
			height: 26,
			backgroundImage: `url(${paymentIconDinersClub})`,
		}
	},
	discover: {
		'&$savedPaymentIcon': {
			width: 59,
			height: 11,
			backgroundImage: `url(${paymentIconDiscover})`,
		}
	},
	jcb: {
		'&$savedPaymentIcon': {
			width: 24,
			height: 18,
			backgroundImage: `url(${paymentIconJcb})`,
		}
	},
	amex: {
		'&$savedPaymentIcon': {
			width: 41,
			height: 11,
			backgroundImage: `url(${paymentIconAmex})`,
		}
	},
	fieldContainer: {
		position: 'relative',
		paddingBottom: '20px !important',
		'& $formInput': {
			'& input': {
				paddingRight: 45,
			}
		}
	},
	emailResetBtn: {
		position: 'absolute',
		top: 27,
		right: 25,
		cursor: 'pointer',
	},
	emailSuccessText: {
		color: '#283339',
		fontWeight: 600,
		fontSize: 11,
		marginTop: 10,
	},
	emailSuccessIcon: {
		display: 'inline-block',
		width: 15,
		height: 17,
		marginLeft: '-20px',
		backgroundImage: `url(${checkMarkGreenRounded})`,
		backgroundSize: '100%',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center',
	},
	authSuccessIcon: {
		position: 'absolute',
		bottom: 56,
		right: 0,
		'&::before': {
			content: '""',
			display: 'block',
			position: 'absolute',
			top: 2,
			left: '-40px',
			width: 16,
			height: 16,
			backgroundImage: `url(${checkMarkGreen})`,
			backgroundSize: '100%',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
		},
	},
	fieldHelpText: {
		color: '#a6a9ab',
		fontSize: 12
	},
	formWrapper: {

	},

	planFeatureBox: {
		borderRadius: 8,
		fontFamily: 'Spartan, sans-serif',
		paddingBottom: 20,
	},
	planFeatureTitle: {
		color: '#FFFFFF',
		fontSize: 16,
		fontWeight: 700,
		textAlign: 'center',
		padding: '16px 10px',
		lineHeight: '26px',
		background: '#8F96A3',
		borderRadius: '8px 8px 0px 0px',
	},
	planFeatureContainer: {
		padding: '20px 20px',
		border: '1px solid #D4D6D7',
		borderTopWidth: 0,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
	},
	planFeature: {
		position: 'relative',
		paddingLeft: 20,
		fontSize: 14,
		lineHeight: '22px',
		color: '#283339',
		fontWeight: 600,
		marginBottom: 7,
		'&::before': {
			content: '""',
			display: 'block',
			position: 'absolute',
			top: 3,
			left: 0,
			width: 16,
			height: 16,
			backgroundImage: `url(${checkMarkGreen})`,
			backgroundSize: '100%',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
		},
		'&$planFeaturesDeleteIcon': {
			'&::before': {
				content: '""',
				width: 14,
				height: 14,
				top: 5,
				backgroundImage: `url(${deleteRed})`,
			},
		},
		'&$planFeaturesExclamationIcon': {
			'&::before': {
				content: '""',
				width: 14,
				height: 14,
				top: 5,
				backgroundImage: `url(${exclamation})`,
			},
		},
	},
	planFeatureIcons: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		'& img': {
			marginLeft: 7,
		}
	},
	planFeaturesExclamationIcon: {},

	paymentInfoWrapper:{
		border: '1px solid #D4D6D7',
		borderRadius: 8,
		padding: '14px 10px',
	},
	paymentInfoBlock: {
		padding: '10px 14px',
		color:  '#283339',
		fontSize: 14,
		lineHeight: '22px',
		fontWeight: 600,
	},
	perMonth: {
		color: '#93999C',
		fontSize: 13,
		lineHeight: '21px',
	},
	total: {
		fontSize: 18,
		lineHeight: '28px',
	},
	sentryBlock:{
		fontSize: 14,
		lineHeight: '22px',
		background: '#F9F9F9',
		borderRadius: 8,
	},


	logosContainer: {
		padding: '0 0 20px',
	},
	logosTitle: {
		fontWeight: 700,
		fontSize: 14,
		color: '#93999C',
		textAlign: 'center',
	},
	logosRow: {
		paddingTop: 5,
		paddingBottom: 5,
	},
	logoCell: {
		margin: 4,
		flex: '1 1 auto',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		'& svg': {
			width: '100%',
			maxWidth: '100%',
		}
	},
	logoAmazon: {
		marginTop: 8,
	},
	logoTrustPilot: {
		'& svg': {
			width: 16,
			height: 16,
			marginLeft: 3,
			marginRight: 3
		},
		'& p': {
			fontWeight: 700,
			fontSize: 14,
			color: '#ffc700',
			textAlign: 'center',
			marginTop: 5,
			maxWidth: 150
		}
	},

	'@media (min-width: 1200px)': {
		formWrapper: {
			position: 'relative',
		},
	},
	'@media (min-width: 1280px)': {
		formWrapper: {
			position: 'relative',
		},
		selectedPlanContainer: {
			minWidth: 300,
		},
	},
	'@media (max-width: 959px)': {
		formWrapper: {
			marginTop: 0
		},
		paymentMethodContainer : {
			marginLeft: 0,
		},
	},
	'@media (max-width: 576px)': {
		pTitle: {
			'&+span': {
				display:'none !important' 
			}
		},
	},
	'@media (max-width: 460px)': {
		sectionHeader: {
			textAlign: 'center',
			padding: '10px 15px',
		},
		separator: {
			margin: '0 10px 30px',
		},
	},
	'@media (max-width: 340px)': {
		paymentIconPayPal: {
			'&::after': {
				content: '""',
				position: 'initial',
			},
		},
	}
});